import * as React from "react";

function ChoosePlan(props) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width={567}
      height={666.546}
      viewBox="0 0 567 666.546"
      {...props}
    >
      <title>{"Choose"}</title>
      <path
        fill="#f5f5f5"
        d="M528.756 115.473l-54.26-16.405-3.337 74.2 57.103 17.212.494-75.007z"
      />
      <path
        fill="#f5f5f5"
        d="M146.808 0v75.501l324.351 97.767 3.337-74.2L146.808 0z"
      />
      <path
        opacity={0.1}
        d="M528.756 115.473l-54.26-16.405-3.337 74.2 57.103 17.212.494-75.007z"
      />
      <path
        fill="#3ad29f"
        d="M528.756 257.593l-54.26-16.405-3.337 74.2 57.103 17.213.494-75.008z"
      />
      <path
        fill="#3ad29f"
        d="M146.808 142.12v75.501l324.351 97.767 3.337-74.2-327.688-99.068z"
      />
      <path
        opacity={0.1}
        d="M528.756 257.593l-54.26-16.405-3.337 74.2 57.103 17.213.494-75.008z"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={7}
        d="M488.291 283.747l8.883 13.323 17.765-22.206"
      />
      <g
        opacity={0.4}
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={7}
      >
        <path d="M488.785 128.303l17.765 31.089M510.991 132.744l-22.206 22.206" />
      </g>
      <path
        fill="#f5f5f5"
        d="M528.756 390.83l-54.26-16.404-3.337 74.2 57.103 17.212.494-75.008z"
      />
      <path
        fill="#f5f5f5"
        d="M146.808 275.358v75.501l324.351 97.767 3.337-74.2-327.688-99.068z"
      />
      <path
        opacity={0.1}
        d="M528.756 390.83l-54.26-16.404-3.337 74.2 57.103 17.212.494-75.008z"
      />
      <g
        opacity={0.4}
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={7}
      >
        <path d="M488.785 403.661l17.765 31.088M510.991 408.102l-22.206 22.206" />
      </g>
      <ellipse
        cx={371.091}
        cy={243.775}
        rx={11.103}
        ry={22.206}
        opacity={0.3}
      />
      <ellipse
        cx={371.091}
        cy={243.775}
        rx={93.266}
        ry={186.533}
        fill="#41bb93"
        opacity={0.1}
      />
      <ellipse
        cx={371.091}
        cy={243.775}
        rx={51.074}
        ry={102.149}
        fill="#fff"
        opacity={0.1}
      />
      <g opacity={0.5} fill="#47e6b1">
        <path d="M3.454 110.291h1.48v8.389h-1.48z" />
        <path d="M8.39 113.745v1.48H0v-1.48z" />
      </g>
      <g opacity={0.5} fill="#47e6b1">
        <path d="M528.454 519.291h1.48v8.389h-1.48z" />
        <path d="M533.39 522.745v1.48H525v-1.48z" />
      </g>
      <g opacity={0.5} fill="#47e6b1">
        <path d="M491.992 341.236h1.48v8.389h-1.48z" />
        <path d="M496.926 344.69v1.48h-8.389v-1.48z" />
      </g>
      <g opacity={0.5} fill="#47e6b1">
        <path d="M428.828 511.978h1.48v8.389h-1.48z" />
        <path d="M433.762 515.432v1.48h-8.389v-1.48z" />
      </g>
      <g opacity={0.5} fill="#47e6b1">
        <path d="M384.415 619.061h1.48v8.389h-1.48z" />
        <path d="M389.35 622.516v1.48h-8.39v-1.48z" />
      </g>
      <g opacity={0.5} fill="#47e6b1">
        <path d="M66.619 240.074h1.48v8.389h-1.48z" />
        <path d="M71.553 243.529v1.48h-8.389v-1.48z" />
      </g>
      <path
        d="M89.66 109.455a1.813 1.813 0 01-1.01-2.192.872.872 0 00.04-.2.91.91 0 00-1.634-.603.871.871 0 00-.101.178 1.813 1.813 0 01-2.192 1.01.871.871 0 00-.2-.039.91.91 0 00-.603 1.634.872.872 0 00.178.1 1.813 1.813 0 011.01 2.192.872.872 0 00-.039.201.91.91 0 001.634.603.872.872 0 00.1-.179 1.813 1.813 0 012.192-1.01.872.872 0 00.201.04.91.91 0 00.603-1.634.872.872 0 00-.179-.101zM422.852 35.262a1.813 1.813 0 01-1.01-2.192.872.872 0 00.039-.2.91.91 0 00-1.634-.604.872.872 0 00-.1.179 1.813 1.813 0 01-2.192 1.01.872.872 0 00-.2-.039.91.91 0 00-.603 1.634.871.871 0 00.178.1 1.813 1.813 0 011.01 2.192.871.871 0 00-.039.2.91.91 0 001.634.603.872.872 0 00.1-.178 1.813 1.813 0 012.192-1.01.871.871 0 00.2.039.91.91 0 00.604-1.634.872.872 0 00-.179-.1zM13.27 299.27a1.813 1.813 0 01-1.01-2.192.871.871 0 00.039-.201.91.91 0 00-1.634-.603.871.871 0 00-.1.179 1.813 1.813 0 01-2.192 1.01.872.872 0 00-.201-.04.91.91 0 00-.603 1.634.871.871 0 00.179.101 1.813 1.813 0 011.01 2.192.872.872 0 00-.04.2.91.91 0 001.634.603.871.871 0 00.101-.178 1.813 1.813 0 012.192-1.01.872.872 0 00.2.039.91.91 0 00.603-1.634.871.871 0 00-.178-.1zM26.593 485.802a1.813 1.813 0 01-1.01-2.191.871.871 0 00.04-.201.91.91 0 00-1.634-.603.871.871 0 00-.1.178 1.813 1.813 0 01-2.192 1.01.872.872 0 00-.201-.039.91.91 0 00-.603 1.634.871.871 0 00.179.1 1.813 1.813 0 011.01 2.192.872.872 0 00-.04.201.91.91 0 001.634.603.871.871 0 00.1-.179 1.813 1.813 0 012.192-1.01.871.871 0 00.201.04.91.91 0 00.603-1.634.871.871 0 00-.179-.1z"
        fill="#4d8af0"
        opacity={0.5}
      />
      <circle cx={248.71} cy={134.471} r={2.961} fill="#f55f44" opacity={0.5} />
      <circle cx={328.653} cy={520.86} r={2.961} fill="#4d8af0" opacity={0.5} />
      <circle
        cx={510.744}
        cy={214.414}
        r={2.961}
        fill="#4d8af0"
        opacity={0.5}
      />
      <circle
        cx={564.039}
        cy={347.651}
        r={2.961}
        fill="#47e6b1"
        opacity={0.5}
      />
      <circle cx={365.663} cy={11.597} r={2.961} fill="#f55f44" opacity={0.5} />
      <path
        fill="#41bb93"
        d="M237.148 167.471l-22.226-.862 1.108-28.575 22.226.862z"
      />
      <path
        d="M316.29 238.112s30.779-14.705 30.286-2.005-31.025 21.056-31.025 21.056z"
        fill="#ffb9b9"
      />
      <path
        d="M299.403 345.573s14.521 35.541 19.887 61.188 13.536 60.943 3.025 85.974-40.391 98.6-40.7 106.537 2.56 15.999-3.79 15.752-40.907-11.126-42.31-15.95 11.79-17.032 11.79-17.032l32.578-102.082-33.99-66.505-24.516 99.215-4.802 123.828s-23.567-7.273-26.988-1.046c0 0-10.56-14.72-11.9-21.131s4.986-128.591 4.986-128.591-21.632-139.163-4.17-138.486 85.864-41.188 120.9-1.671z"
        fill="#41bb93"
      />
      <path
        d="M278.071 608.674s16.109 35.603 17.635 37.252 12.023 17.956 4.085 17.648-26.68-8.984-40.476-22.239-31.984-36.218-30.335-37.744 12.947-5.858 12.947-5.858zM213.708 628.437s.972 15.937 3.9 22.41 2.56 16-5.378 15.691-28.453-4.283-28.453-4.283-1.218-9.587.431-11.113 8.677-18.742 5.686-23.628 23.814.923 23.814.923z"
        fill="#575a89"
      />
      <path
        d="M201.964 111.254s-16.922 26.373-23.518 32.477 11.962 19.543 11.962 19.543l33.215 4.468s-.418-30.225 1.293-33.339-22.952-23.149-22.952-23.149z"
        fill="#ffb9b9"
      />
      <path
        d="M230.835 145.762s-6.843 12.454-13.193 12.208-39.196-14.24-40.599-19.063-10.88 34.556-10.88 34.556l80.372 141.44 19.605-13.548-9.5-83.045-7.801-44.82z"
        fill="#41bb93"
      />
      <path
        d="M174.079 272.346c3.206 6.707 5.208 13.7 4.93 20.86-.012.318-.024.635-.053.952-.76 14.693-6.173 31.686-8.115 44.044-1.409 8.865-1.008 15.336 4.18 16.857 12.577 3.667-1.834 6.288 46.826 22.485s57.151 2.216 57.275-.96-6.892-27.295-5.242-28.821 23.074 19.974 29.547 17.045.739-19.05.739-19.05-14.583-33.955-14.275-41.892-22.09-45.375-22.09-45.375l-15.233-99.166s-5.858-12.947-13.734-14.842-14.41 2.62-14.41 2.62l13.179 29.13 13.905 51.417-2.326 18.99s-16.17-34.016-26.79-47.147-33.264-44.218-33.264-44.218-5.287-17.838-1.296-23.168c3.992-5.347-16.647-6.147-25.446 15.77-4.664 11.617-12.236 28.94-16.98 45.069-4.226 14.288-6.223 27.646-2.035 35.28 6.4 11.665 22.5 26.996 30.708 44.12z"
        fill="#575a89"
      />
      <path
        d="M143.37 228.227c6.401 11.664 22.5 26.995 30.709 44.119 2.143-7.724 4.759-15.715 4.759-15.715s10.03-53.669-19.64-67.539a19.858 19.858 0 00-13.791 3.854c-4.227 14.288-6.224 27.646-2.036 35.28z"
        opacity={0.1}
      />
      <path
        d="M261.157 224.845l25.154 7.335 34.926 1.354 3.593 30.348-57.398 4.134s-14.336-40.304-6.275-43.171z"
        fill="#575a89"
      />
      <path
        d="M220.139 326.884s33.652 5.583 25.971 15.71-37.492-.52-37.492-.52z"
        fill="#ffb9b9"
      />
      <path
        d="M178.956 294.158c-.76 14.693-6.173 31.686-8.115 44.044 10.72 10.147 20.915 19.096 24.756 19.245 7.938.307 20.7-.788 25.401.985s7.458-28.33 7.458-28.33-2.805-9.648-15.321-14.903c-8.448-3.556-24.641-13.198-34.179-21.041z"
        opacity={0.1}
      />
      <path
        d="M159.567 179.567s-26.865-4.222-25.414 40.353-2.832 73.027 7.973 81.396 45.903 46.298 53.84 46.605 20.7-.787 25.401.985 7.459-28.33 7.459-28.33-2.806-9.648-15.322-14.903-42.001-23.887-41.755-30.238 7.458-28.33 7.458-28.33 10.03-53.668-19.64-67.538z"
        fill="#575a89"
      />
      <circle cx={225.654} cy={115.353} r={34.952} fill="#ffb9b9" />
      <path
        d="M249.189 65.256a6.749 6.749 0 002.938 1.475 2.097 2.097 0 002.43-1.684c.8 1.659 1.703 3.426 3.335 4.277s4.158.138 4.393-1.688a7.706 7.706 0 001.774 3.744c1.013.965 2.85 1.21 3.734.124-.715 3.908-.274 7.926-.498 11.892s-1.282 8.17-4.279 10.779c-4.37 3.803-10.94 2.864-16.689 2.144a5.066 5.066 0 00-2.615.143c-2.153.917-2.055 3.913-2.084 6.252a17.373 17.373 0 01-15.212 16.498 8.709 8.709 0 01-6.473-1.58c-1.632-1.383-2.465-3.638-4.336-4.677-3.042-1.69-6.731.775-8.955 3.451s-4.416 5.97-7.862 6.46c-4.557.648-8.028-3.996-9.73-8.272a48.223 48.223 0 01.958-37.47c9.515-20.741 42.018-24.022 59.17-11.868z"
        fill="#2f2e41"
      />
    </svg>
  );
}

export default ChoosePlan;
